import React from "react";
import MapContainer from "./Map/MapContainer";
class GoogleMap extends React.Component{
    constructor(props) {
        super();
        this.state = {
          isFetching: false,
  
          }
    }
    
 render(){

   return (
            <>
          
             <MapContainer/>
        

            </>
    
      );
    }
};
    

export default GoogleMap;